import { render, staticRenderFns } from "./ECAssessment.vue?vue&type=template&id=6f709784&scoped=true"
import script from "./ECAssessment.vue?vue&type=script&lang=js"
export * from "./ECAssessment.vue?vue&type=script&lang=js"
import style0 from "./ECAssessment.vue?vue&type=style&index=0&id=6f709784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f709784",
  null
  
)

export default component.exports